export default "__VITE_ASSET__688Qa3pb__"